import idb from "@/plugins/indexdb.js";
import RetouchingRepairRepository from "@/repositories/products/retouchingRepairRepository";

import retouchingRepairDefaultForm from "./forms/retouchingRepair";

export default {
  namespaced: true,
  state: {
    retouchingRepair: retouchingRepairDefaultForm
  },
  mutations: {
    SET_RETOUCHING_REPAIR(state, payload) {
      state.retouchingRepair = Object.assign(
        {},
        state.retouchingRepair,
        payload
      );
    },

    RESET_RETOUCHING_REPAIR(state) {
      state.retouchingRepair = retouchingRepairDefaultForm;
    }
  },
  actions: {
    /**
     * Get retouchingRepair product by uuid
     *
     * @param {String} retouching_repair_uuid retouchingRepair uuid
     */
    async get({ commit }, retouching_repair_uuid) {
      try {
        const { data } = await RetouchingRepairRepository.get(
          retouching_repair_uuid
        );
        commit("SET_RETOUCHING_REPAIR", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    resetProduct({ commit }) {
      commit("RESET_RETOUCHING_REPAIR");
    },

    /**
     * Get retouching repair product from IndexedDB
     *
     * @param {String} retouching_repair_uuid Retouching repair uuid
     */
    async getFromLocal({ commit }, retouching_repair_uuid) {
      const retouchingRepair = await idb.db.retouching_repair.get(
        retouching_repair_uuid
      );

      // If not found return null
      if (!retouchingRepair) throw new Error("Produit non trouvé");

      commit("SET_RETOUCHING_REPAIR", retouchingRepair);

      return retouchingRepair;
    },

    // Get retouchingRepair from API
    async getRetouchingRepair(context, retouching_repair_uuid) {
      try {
        const { data } = await RetouchingRepairRepository.getRetouchingRepair(
          retouching_repair_uuid
        );
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new retouchingRepair
    async createRetouchingRepair(context, payload) {
      try {
        const {
          data
        } = await RetouchingRepairRepository.createRetouchingRepair(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Get local retouchingRepair from IndexedDB
    async getLocalRetouchingRepair(context, retouching_repair_uuid) {
      const res = await idb.db.retouching_repair.get(retouching_repair_uuid);
      if (res) {
        return res;
      }
    }
  }
};
